var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"router-fade","mode":"out-in"}},[_c('div',{staticClass:"app-content"},[_c('router-view'),(_vm.loading)?_c('div',{staticClass:"loading"},[_c('a-icon',{attrs:{"width":"64px","type":"loading"}})],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }